<script>
import { Icon } from '@/ui/components/icon/Icon';

export default {
  name: 'IconInfoCircle',
  components: {
    Icon,
  },
  props: {
    text: {
      type: String,
      required: true,
    },
  },
  render(h) {
    return h('span', [
      h(Icon, {
        props: {
          size: 'xs',
          iconPack: 'fal',
          icon: 'info-circle',
          classes: 'feature-explanation-icon',
        },
        directives: [
          {
            name: 'tooltip',
            value: {
              content: `${this.text}`,
              placement: 'bottom'
            },
          }
        ]
      })
    ])
  }
}
</script>
